import { forAllCallback, acfOnRender } from "../../../scripts/utils/helpers";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default () => {
    forAllCallback(".content-block.content-block--card-deck", (el) => {
        const init = () => {
            const cards = el.querySelectorAll(".card");

            if (cards.length) {
                cards.forEach((item, key) => {
                    const tween = gsap.from(item, {
                        x: 50,
                        y: 50,
                        opacity: 0,
                        duration: 2,
                        delay: 0.2 + 0.2 * key,
                    });
                    ScrollTrigger.create({
                        trigger: el,
                        start: "top bottom",
                        end: "bottom top",
                        animation: tween,
                        once: false,
                        toggleActions: "restart none restart none",
                    });
                });
            }
        };

        init();

        acfOnRender(() => {
            console.log("kwp-block-card-deck");
            init();
        }, "kwp-block-card-deck");
    });
};
